module.exports = __webpack_public_path__ + "static/media/broadcast-tower.438421e9.svg";